'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TestimonialFiltersProps {
  selectedVariety: string;
  selectedRating: string;
  selectedSort: string;
  onVarietyChange: (variety: string) => void;
  onRatingChange: (rating: string) => void;
  onSortChange: (sort: string) => void;
}

const TestimonialFilters = ({
  selectedVariety,
  selectedRating,
  selectedSort,
  onVarietyChange,
  onRatingChange,
  onSortChange,
}: TestimonialFiltersProps) => {
  const varieties = [
    { label: 'All Varieties', value: 'all' },
    { label: 'Yellow Labrador', value: 'yellow' },
    { label: 'Black Labrador', value: 'black' },
    { label: 'Chocolate Labrador', value: 'chocolate' },
    { label: 'English Labrador', value: 'english' },
    { label: 'Fox Red Labrador', value: 'fox-red' },
  ];

  const ratings = [
    { label: 'All Ratings', value: 'all' },
    { label: '5 Stars', value: '5' },
    { label: '4+ Stars', value: '4' },
    { label: '3+ Stars', value: '3' },
  ];

  const sortOptions = [
    { label: 'Most Recent', value: 'recent' },
    { label: 'Highest Rated', value: 'rating' },
    { label: 'Most Helpful', value: 'helpful' },
  ];

  return (
    <div className="rounded-xl bg-card p-6 shadow-warm">
      <div className="mb-5 flex items-center gap-3">
        <Icon name="FunnelIcon" size={24} variant="outline" className="text-primary" />
        <h3 className="font-heading text-lg font-semibold text-foreground">
          Filter Reviews
        </h3>
      </div>

      <div className="grid gap-5 md:grid-cols-3">
        {/* Variety Filter */}
        <div>
          <label
            htmlFor="variety-filter"
            className="mb-2 block text-sm font-medium text-foreground"
          >
            Puppy Variety
          </label>
          <select
            id="variety-filter"
            value={selectedVariety}
            onChange={(e) => onVarietyChange(e.target.value)}
            className="w-full rounded-md border border-border bg-input px-4 py-2.5 text-foreground transition-smooth hover:border-primary/30 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
          >
            {varieties.map((variety) => (
              <option key={variety.value} value={variety.value}>
                {variety.label}
              </option>
            ))}
          </select>
        </div>

        {/* Rating Filter */}
        <div>
          <label
            htmlFor="rating-filter"
            className="mb-2 block text-sm font-medium text-foreground"
          >
            Minimum Rating
          </label>
          <select
            id="rating-filter"
            value={selectedRating}
            onChange={(e) => onRatingChange(e.target.value)}
            className="w-full rounded-md border border-border bg-input px-4 py-2.5 text-foreground transition-smooth hover:border-primary/30 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
          >
            {ratings.map((rating) => (
              <option key={rating.value} value={rating.value}>
                {rating.label}
              </option>
            ))}
          </select>
        </div>

        {/* Sort Filter */}
        <div>
          <label
            htmlFor="sort-filter"
            className="mb-2 block text-sm font-medium text-foreground"
          >
            Sort By
          </label>
          <select
            id="sort-filter"
            value={selectedSort}
            onChange={(e) => onSortChange(e.target.value)}
            className="w-full rounded-md border border-border bg-input px-4 py-2.5 text-foreground transition-smooth hover:border-primary/30 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
          >
            {sortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default TestimonialFilters;